/* Amalife — "Абонирай се" gift box.
   Automatic welcome dialog, email captured by Shopify's
   own customer form. No third-party script. */
(function () {
  'use strict';

  var SEEN_KEY = 'ama_gift_subscribed';
  var VISIT_KEY = 'ama_gift_shown_this_visit';
  var VISIT_START_KEY = 'ama_gift_visit_started_at';
  var AUTO_DELAY_MS = 120000;
  var autoEligibleAt = 0;
  var box, panel, lastFocus = null, autoPending = false;

  function q(sel, root) { return (root || document).querySelector(sel); }

  // Both newsletter entry points use the checkbox as the actual submitted
  // accepts_marketing field. Native required validation also works without JS.
  function initMarketingConsent() {
    document.querySelectorAll('[data-ama-marketing-consent]').forEach(function (checkbox) {
      if (checkbox.dataset.amaConsentReady === 'true' || !checkbox.form) return;
      checkbox.dataset.amaConsentReady = 'true';
      var form = checkbox.form;
      function sync() {
        form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(function (button) {
          button.disabled = !checkbox.checked;
        });
      }
      checkbox.addEventListener('change', sync);
      form.addEventListener('reset', function () { setTimeout(sync, 0); });
      sync();
    });
  }

  document.addEventListener('shopify:section:load', initMarketingConsent);
  window.addEventListener('pageshow', initMarketingConsent);
  document.addEventListener('submit', function (event) {
    var checkbox = q('[data-ama-marketing-consent]', event.target);
    if (checkbox && !checkbox.checked) {
      event.preventDefault();
      checkbox.reportValidity();
    }
  }, true);

  /* ---------------------------------------------------------------- open/close */

  function open() {
    if (!box) return;
    autoPending = false;
    try { sessionStorage.setItem(VISIT_KEY, '1'); } catch (e) {}
    lastFocus = document.activeElement;
    box.classList.add('is-open');
    box.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var first = q('input[type="email"]', box) || q('[data-ama-gift-close]', box);
    if (first) setTimeout(function () { first.focus(); }, 40);
  }

  function close() {
    if (!box) return;
    box.classList.remove('is-open');
    box.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* -------------------------------------------------- yield the bottom-left corner

     The cookie banner sits in exactly the same place and must never be covered:
     consent has to stay reachable. The button steps aside while the banner is
     up and returns the moment it is dismissed. */

  function consentVisible() {
    var c = q('.ama-consent');
    return !!c && !c.hidden;
  }

  function tryAutoOpen() {
    if (!autoPending || Date.now() < autoEligibleAt || consentVisible() || q('.ama-natures-gift[open]')) return;
    try {
      if (sessionStorage.getItem(VISIT_KEY) === '1' || localStorage.getItem(SEEN_KEY) === '1') {
        autoPending = false;
        return;
      }
    } catch (e) {}
    open();
  }

  function watchConsent() {
    var c = q('.ama-consent');
    if (!c) return;
    new MutationObserver(tryAutoOpen).observe(c, { attributes: true, attributeFilter: ['hidden'] });
  }

  /* --------------------------------------------------------------- validation */

  function fail(msg) {
    var boxEl = q('[data-ama-gift-error]');
    if (!boxEl) return;
    boxEl.textContent = msg;
    boxEl.hidden = false;
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-ama-gift-form]')) return;
    var field = q('input[type="email"]', form);
    var value = field ? (field.value || '').trim() : '';
    // deliberately loose — something@something.tld, no attempt to out-guess the RFC
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(value)) {
      event.preventDefault();
      fail((window.amaI18n && window.amaI18n.email_error || 'Моля, въведи валиден имейл.'));
      return;
    }
    /* Deliberately no disabling here. Shopify puts hCaptcha on this form, and a
       challenge can appear between the click and the post — a button greyed out
       as (window.amaI18n && window.amaI18n.sending || "Изпращаме…") would strand the shopper with no way to retry. The page
       navigates away on success anyway. */
    var errBox = q('[data-ama-gift-error]', form);
    if (errBox) errBox.hidden = true;
  }

  /* --------------------------------------------------------------- copy code */

  function onCopy(button) {
    var code = q('[data-ama-gift-code]');
    if (!code) return;
    var text = code.textContent.trim();
    var done = function () {
      var was = button.textContent;
      button.textContent = (window.amaI18n && window.amaI18n.copied || 'Копирано');
      setTimeout(function () { button.textContent = was; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, done);
    } else {
      // older Safari and any non-secure context
      var t = document.createElement('textarea');
      t.value = text; t.setAttribute('readonly', '');
      t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(t);
      done();
    }
  }

  /* --------------------------------------------------------------------- init */

  function init() {
    initMarketingConsent();
    box = q('[data-ama-gift]');
    if (!box) return;
    panel = q('.ama-gift__panel', box);

    watchConsent();
    var naturesGift = q('.ama-natures-gift');
    if (naturesGift) naturesGift.addEventListener('close', tryAutoOpen);

    document.addEventListener('click', function (event) {
      var t = event.target;
      if (t.closest('[data-ama-gift-open]')) return open();
      if (t.closest('[data-ama-gift-close]')) return close();
      var copy = t.closest('[data-ama-gift-copy]');
      if (copy) return onCopy(copy);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && box.classList.contains('is-open')) close();
    });

    document.addEventListener('submit', onSubmit, true);

    /* Shopify posts the customer form as a real navigation and returns with
       ?customer_posted=true, so the success panel is already rendered — reopen
       the dialog on that reply instead of leaving the shopper on a silent page. */
    if (q('[data-ama-gift-code-box]', box) || /customer_posted=true/.test(location.search)) {
      try { localStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
      if (q('[data-ama-gift-code-box]', box)) setTimeout(open, 300);
    } else if (q('.errors', box)) {
      setTimeout(open, 300);
    } else {
      // Keep the two-minute visit clock when the shopper changes pages.
      var now = Date.now();
      var startedAt = now;
      try {
        var savedStart = Number(sessionStorage.getItem(VISIT_START_KEY));
        if (savedStart > 0 && savedStart <= now) startedAt = savedStart;
        else sessionStorage.setItem(VISIT_START_KEY, String(now));
      } catch (e) {}
      autoEligibleAt = startedAt + AUTO_DELAY_MS;
      autoPending = true;
      setTimeout(tryAutoOpen, Math.max(0, autoEligibleAt - now));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
